


import { Component, Vue, Prop, Emit, Ref } from 'vue-property-decorator';
import { ContactFormFields } from './ContactForm.models';
import FormField from '@/components/FormField/index.vue';
import Checkbox from '@/components/Checkbox/index.vue';
import { gsap } from 'gsap';
import { FormFieldData } from '@/components/FormField/formfield.models';

@Component({
  components: { FormField, Checkbox }
})
export default class ContactForm extends Vue {
  @Prop() private fields!: ContactFormFields;
  @Prop() private privacyApproved!: boolean;

  @Ref('formFields') private formFields!: Vue[];

  private showMessageField = false;

  @Emit('submit')
  private submitClicked() {
    return;
  }

  @Emit('checkbox-input')
  private handleCheckboxInput() {
    return;
  }

  @Emit('input')
  private handleInput(value: string, field: keyof ContactFormFields) {
    return { value, field };
  }

  @Emit('focus')
  private handleFocus() {
    return;
  }

  private toggleMessage() {
    this.showMessageField = !this.showMessageField;

    if (this.showMessageField) {
      this.$emit('scroll-to-bottom');
    } else {
      this.fields.message.value = '';
      this.$emit('scroll-to-top');
    }
  }

  private get fieldsList() {
    return Object.entries(this.fields);
  }

  /**
   * returns the field data for the given field name
   * or null if no such field can be found
   */
  private getFieldByName(name: string): FormFieldData | null {
    const candidate = this.fieldsList.find(([fieldName]) => fieldName === name);
    if (candidate) {
      return candidate[1];
    }
    return null;
  }

  /**
   * returns the value of the field identified by name
   */
  private getFieldValue(name: string): string | null {
    const fieldData = this.getFieldByName(name);
    if (null === fieldData) {
      return null;
    }
    return fieldData.value;
  }

  private fieldBeforeLeave(el: HTMLElement, done: () => void) {
    if (el.classList.value.includes('extra')) {
      gsap.fromTo(el, { height: el.offsetHeight }, { height: 0, duration: 0.3, delay: 0.3, onComplete: done });
    } else {
      done();
    }
  }

  /**
   * returns true if the form field identified by name should be show,
   * false if not
   */
  public showFormField(name: string) {
    if (name === 'message') {
      return this.showMessageField;
    }

    if (['landFieldNumber', 'landZip', 'landCity'].includes(name)) {
      const landAvailable = this.getFieldValue('landAvailable');

      return landAvailable !== null && landAvailable.length > 0 && landAvailable !== 'NONE';
    }

    return true;
  }
}
